import {
    AUTHORIZE_SETVALUE,
    AUTHORIZE_OPEN,
    AUTHORIZE_CLOSE,
} from "./AuthorizeConstants"

export const setValue = (id, value) => ({ type: AUTHORIZE_SETVALUE, id, value });
export const setLoading = (value) => ({ type: AUTHORIZE_SETVALUE, id: "isLoading", value });
export const open = (title, authType = 0, data, onAccept, onDeny) => ({ type: AUTHORIZE_OPEN, title, authType, data, onAccept, onDeny });
export const close = () => ({ type: AUTHORIZE_CLOSE });